import React from 'react';
// import logo from './logo.svg';
import './App.css';

// package
// import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

// page items
import MainPage from "./public/pages/ts/mainPage";
import AboutPage from './public/pages/ts/aboutPage';
import OceanPage from './public/pages/ts/oceanPage';
import WeatherPanelPage from './public/pages/ts/weatherPanelPage';

function App() {
  return (
    <Router>
        <Routes>
          <Route index path='/' element={<MainPage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/oceanweather' element={<OceanPage />} />
          <Route path='/weatherpanel' element={<WeatherPanelPage />} />
          <Route path='/*' element={<MainPage />} />
        </Routes>
    </Router>
  );
}

export default App;
